import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";
const buttonVariants = cva("ui-button", {
    variants: {
        variant: {
            default: "ui-button-primary",
            destructive: "ui-button-danger",
            outline: "ui-button-secondary",
            secondary: "ui-button-muted",
            ghost: "ui-button-ghost",
            link: "ui-button-link",
        },
        size: {
            default: "ui-button-md",
            sm: "ui-button-sm",
            lg: "ui-button-lg",
            icon: "ui-button-icon",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
function Button({ className, variant, size, asChild = false, ...props }) {
    const Comp = asChild ? Slot : "button";
    return (_jsx(Comp, { "data-slot": "button", className: cn(buttonVariants({ variant, size, className })), ...props }));
}
export { Button, buttonVariants };
//# sourceMappingURL=button.js.map